export default __webpack_public_path__ + "static/media/Group_1432.2b1218a5.svg";